import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "core-js/stable";
import "@/index.css";
import App from "@/App";
import PropertyWebsite from "@/PropertyWebsite";
import LandingPage from "@/components/LandingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { usePageTitle } from "@/hooks/usePageTitle";

// Tiny render-prop component so we can mount the hook inside BrowserRouter
// without restructuring the rest of the routing tree.
const TitleWatcher = () => {
  usePageTitle();
  return null;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TitleWatcher />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/property/:slug" element={<PropertyWebsite />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentSuccess />} />
        <Route path="/login" element={<App />} />
        <Route path="/app/*" element={<App />} />
        <Route path="/schedule/:businessId" element={<App />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
